export const USR_CERT_ENTITLEMENT_VALUEKEY = '-4';
export const RLE_CERT_ENTITLEMENT_VALUEKEY = '-2';
export const ACC_CERT_ENTITLEMENT_VALUEKEY = '0';
export const ENT_CERT_ENTITLEMENT_VALUEKEY = '>0';

export const OBJECTS_TO_BE_INCLUDED_USERS = 'users';
export const OBJECTS_TO_BE_INCLUDED_ROLES = 'roles';
export const OBJECTS_TO_BE_INCLUDED_ACCOUNTS = 'accounts';
export const OBJECTS_TO_BE_INCLUDED_ENTITLEMENTS = 'entitlements';

export const UM_DEFAULT_ROW_FILTER = [
  {
    label: 'User',
    value: USR_CERT_ENTITLEMENT_VALUEKEY,
    isParent: false,
    isChecked: true,
    isDisabled: false,
    isLast: false,
    options: [
      {
        label: 'Role',
        value: RLE_CERT_ENTITLEMENT_VALUEKEY,
        isParent: false,
        isChecked: true,
        isDisabled: false,
        isLast: false,
        options: [],
      },
      {
        label: 'Account',
        value: ACC_CERT_ENTITLEMENT_VALUEKEY,
        isParent: false,
        isChecked: true,
        isDisabled: false,
        isLast: false,
        options: [
          {
            label: 'Entitlement',
            value: ENT_CERT_ENTITLEMENT_VALUEKEY,
            isParent: false,
            isChecked: true,
            isDisabled: false,
            isLast: false,
            options: [],
          },
        ],
      },
    ],
  },
];

export const AO_DEFAULT_ROW_FILTER = [
  {
    label: 'Account',
    value: ACC_CERT_ENTITLEMENT_VALUEKEY,
    isParent: false,
    isChecked: true,
    isDisabled: false,
    isLast: false,
    options: [
      {
        label: 'Entitlement',
        value: ENT_CERT_ENTITLEMENT_VALUEKEY,
        isParent: false,
        isChecked: true,
        isDisabled: false,
        isLast: false,
        options: [],
      },
      {
        label: 'Role',
        value: RLE_CERT_ENTITLEMENT_VALUEKEY,
        isParent: false,
        isChecked: true,
        isDisabled: false,
        isLast: false,
        options: [],
      },
    ],
  },
];

export const ROWS_CONSTANT_MAP = {
  [USR_CERT_ENTITLEMENT_VALUEKEY]: OBJECTS_TO_BE_INCLUDED_USERS,
  [RLE_CERT_ENTITLEMENT_VALUEKEY]: OBJECTS_TO_BE_INCLUDED_ROLES,
  [ACC_CERT_ENTITLEMENT_VALUEKEY]: OBJECTS_TO_BE_INCLUDED_ACCOUNTS,
  [ENT_CERT_ENTITLEMENT_VALUEKEY]: OBJECTS_TO_BE_INCLUDED_ENTITLEMENTS,
};

export const UPDATE_ROW_FILTER_MAPPING = {
  [USR_CERT_ENTITLEMENT_VALUEKEY]: 'User',
  [RLE_CERT_ENTITLEMENT_VALUEKEY]: 'Role',
  [ACC_CERT_ENTITLEMENT_VALUEKEY]: 'Account',
  [ENT_CERT_ENTITLEMENT_VALUEKEY]: 'Entitlement',
};

export const UPDATE_ROW_FILTER_MAPPING_WITH_OBJECTS_TO_BE_INCLUDED = {
  [UPDATE_ROW_FILTER_MAPPING[USR_CERT_ENTITLEMENT_VALUEKEY]]:
    OBJECTS_TO_BE_INCLUDED_USERS,
  [UPDATE_ROW_FILTER_MAPPING[RLE_CERT_ENTITLEMENT_VALUEKEY]]:
    OBJECTS_TO_BE_INCLUDED_ROLES,
  [UPDATE_ROW_FILTER_MAPPING[ACC_CERT_ENTITLEMENT_VALUEKEY]]:
    OBJECTS_TO_BE_INCLUDED_ACCOUNTS,
  [UPDATE_ROW_FILTER_MAPPING[ENT_CERT_ENTITLEMENT_VALUEKEY]]:
    OBJECTS_TO_BE_INCLUDED_ENTITLEMENTS,
};

export const OBJECTS_TO_BE_INCLUDED_MAPPING_WITH_UPDATE_ROW_FILTER_MAPPING = {
  [OBJECTS_TO_BE_INCLUDED_USERS]: 'User',
  [OBJECTS_TO_BE_INCLUDED_ROLES]: 'Role',
  [OBJECTS_TO_BE_INCLUDED_ACCOUNTS]: 'Account',
  [OBJECTS_TO_BE_INCLUDED_ENTITLEMENTS]: 'Entitlement',
};

// EO campaigns

export const EO_ENT_CERT_ENTITLEMENT_VALUEKEY = '0';
export const EO_ACC_CERT_ENTITLEMENT_VALUEKEY = '1';
export const EO_CHILD_CERT_ENTITLEMENT_VALUEKEY = '-1';
export const EO_GROUP_BY_CERT_ENTITLEMENT_VALUEKEY = 'EO_END_POINT';

// EO campaigns
export const EO_OBJECTS_TO_BE_INCLUDED_ACCOUNTS = 'accounts';
export const EO_OBJECTS_TO_BE_INCLUDED_ENTITLEMENTS = 'entitlements';
export const EO_OBJECTS_TO_BE_INCLUDED_CHILD_ENTITLEMENTS = 'childentitlements';

// EO campaign
export const EO_OBJECTS_TO_BE_INCLUDED_MAPPING_WITH_UPDATE_ROW_FILTER_MAPPING =
  {
    [EO_OBJECTS_TO_BE_INCLUDED_ACCOUNTS]: 'Account',
    [EO_OBJECTS_TO_BE_INCLUDED_CHILD_ENTITLEMENTS]: 'Child Entitlement',
    [EO_OBJECTS_TO_BE_INCLUDED_ENTITLEMENTS]: 'Entitlement',
  };

// EO campaign
export const EO_ROWS_CONSTANT_MAP = {
  [EO_ENT_CERT_ENTITLEMENT_VALUEKEY]: EO_OBJECTS_TO_BE_INCLUDED_ENTITLEMENTS,
  [EO_ACC_CERT_ENTITLEMENT_VALUEKEY]: EO_OBJECTS_TO_BE_INCLUDED_ACCOUNTS,
  [EO_CHILD_CERT_ENTITLEMENT_VALUEKEY]:
    EO_OBJECTS_TO_BE_INCLUDED_CHILD_ENTITLEMENTS,
};

// EO campaign
export const EO_UPDATE_ROW_FILTER_MAPPING = {
  [EO_ENT_CERT_ENTITLEMENT_VALUEKEY]: 'Entitlement',
  [EO_ACC_CERT_ENTITLEMENT_VALUEKEY]: 'Account',
  [EO_CHILD_CERT_ENTITLEMENT_VALUEKEY]: 'ChildEntitlement',
};

// EO campaign
export const EO_UPDATE_ROW_FILTER_MAPPING_WITH_OBJECTS_TO_BE_INCLUDED = {
  [EO_UPDATE_ROW_FILTER_MAPPING[EO_ENT_CERT_ENTITLEMENT_VALUEKEY]]:
    EO_OBJECTS_TO_BE_INCLUDED_ENTITLEMENTS,
  [EO_UPDATE_ROW_FILTER_MAPPING[EO_ACC_CERT_ENTITLEMENT_VALUEKEY]]:
    EO_OBJECTS_TO_BE_INCLUDED_ACCOUNTS,
  [EO_UPDATE_ROW_FILTER_MAPPING[EO_CHILD_CERT_ENTITLEMENT_VALUEKEY]]:
    EO_OBJECTS_TO_BE_INCLUDED_CHILD_ENTITLEMENTS,
};

export const EO_DEFAULT_ROW_FILTER = [
  {
    label: 'Entitlement',
    value: EO_ENT_CERT_ENTITLEMENT_VALUEKEY,
    isParent: false,
    isChecked: true,
    isDisabled: false,
    isLast: false,
    options: [
      {
        label: 'Account',
        value: EO_ACC_CERT_ENTITLEMENT_VALUEKEY,
        isParent: false,
        isChecked: true,
        isDisabled: false,
        isLast: false,
        options: [],
      },
      {
        label: 'Child Entitlement',
        value: EO_CHILD_CERT_ENTITLEMENT_VALUEKEY,
        isParent: false,
        isChecked: true,
        isDisabled: false,
        isLast: false,
        options: [],
      },
    ],
  },
];
